/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { Redirect, Route } from 'react-router-dom';
import { FitinsurAPI } from "utils";
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import LoadingPage from "flows/base/pages/loadingPage/index";
import Error403Page from "flows/base/pages/error403/index";
import Routes from "constants/Routes";
import Access from "constants/Access";

export default function PrivateRoute(props) {
    const { component: Component, path, routePermissions } = props;
    const authContext = useContext(GlobalAuthContext);
    const fitinsurApi = new FitinsurAPI();

    const [permissions, setPermissions] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isForbiddenRoute, setIsForbiddenRoute] = useState(false);

    useEffect(() => {
        getPermissions()
    }, [props.location])

    async function getPermissions() {
        //TODO: descomentar quando implementar todas as rotas
        if (!routePermissions) return setIsLoading(false);

        setIsLoading(true);

        //check application access
        const hasApplicationAccess = await getApplicationAccess();
        if (!hasApplicationAccess) {
            setIsForbiddenRoute(true);
            setIsLoading(false);
        }

        //check page access
        const userPermissions = {};
        for (const [permission, idDomain] of Object.entries(routePermissions)) {
            if (!userPermissions[permission]) userPermissions[permission] = {};

            const response = await fitinsurApi
                .requestAccess("", "READ", idDomain, null, null, authContext.token)
                .then((response) => response.json())

            userPermissions[permission] = response.ret_code === 200;
        }

        //if (!userPermissions.READ) setIsForbiddenRoute(true);
        setPermissions(userPermissions);
        setIsLoading(false);
    }

    async function getApplicationAccess() {
        const response = await fitinsurApi
            .requestAccess("", "READ", Access.APLICATION, null, null, authContext.token)
            .then((response) => response.json());

        if (response.ret_code !== 200) {
            return false;
        }

        return true;
    }

    return (
        <Route path={path} render={() => {
            //if (isLoading) return <LoadingPage />
            if (isForbiddenRoute) return <Error403Page />;
            if (authContext.status) return <Component {...props} match={props.computedMatch} permissions={permissions || {}} />;
            return <Redirect to={Routes.LOGIN} />
        }} />
    )
}